import { Alert } from '@modules/common/components/alert';

const ErrorMessage = ({
  error,
  'data-testid': dataTestid,
  asAlert = false,
}: {
  error?: string | null;
  'data-testid'?: string;
  asAlert?: boolean;
}) => {
  if (!error) {
    return null;
  }

  if (asAlert) {
    return (
      <div data-testid={dataTestid}>
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  return (
    <div
      role="alert"
      className="pt-2 text-sm text-fg-danger-strong"
      data-testid={dataTestid}
    >
      <span>{error}</span>
    </div>
  );
};

export default ErrorMessage;
